export default __webpack_public_path__ + "static/media/DGX-H200.818dcf83.png";